<template>
  <v-navigation-drawer
    v-model="isShowNav"
    temporary
    absolute
  >
    <v-toolbar text>
      <v-list>
        <v-list-item>
          <v-list-item-title class="title">
            {{ navigationTitle }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-toolbar>
    <v-divider />
    <v-list>
      <v-list-item
        v-for="item in navItems"
        :key="item.text"
        @click="goToRoute(item.link)"
      >
        <v-list-item-action>
          <v-icon>
            {{ item.icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ item.text }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'the-navigation-drawer',
  props: {
    navItems: Array,
    navigationTitle: String
  },
  computed: {
    ...mapState('navbar', ['showMobileNav']),
    isShowNav: {
      get() {
        return this.showMobileNav
      },
      set(value) {
        this.setShowMobileNav(value)
      }
    }
  },
  methods: {
    ...mapActions('navbar', ['setShowMobileNav']),
    goToRoute(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss" scoped>
  .v-list-item__title{
    font-weight: 800;
  }
</style>
